<div [class.asiakaskortti]="naytaKortti()">
  @if (naytaKortti()) {
    <div class="kortin-ylaosa">
      <mat-icon class="asiakasikoni">{{ asiakasikoni() }}</mat-icon>
      <button type="button" class="kortin-nimi" (click)="muokkaa.emit()" [attr.title]="'lasku.muokkaa-asiakkaan-tietoja' | translate | async">
        <span class="nimi">{{ nimiTekstina }}</span>
        @if (osoite) {
          <span class="osoite">{{ osoite }}</span>
        }
      </button>
      <button type="button" class="poista-valinta" (click)="poistaValittu()" [attr.aria-label]="'lasku.poista-asiakas-laskulta' | translate | async">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    @if (asiakashaunVihjetekstiObservable | async; as asiakashaunVihjeteksti) {
      <div class="kortin-vihje" [class.red-warning]="asiakashaunVihjeteksti === ('lasku.muokkaa-asiakasta' | translate | async)">
        @if (naytaCheck()) {
          <mat-icon class="green-text">done</mat-icon>
        }
        {{ asiakashaunVihjeteksti }}
      </div>
    }
    <ng-content></ng-content>
  } @else {
    <div class="hakulaatikko">
      <mat-icon>search</mat-icon>
      <input #asiakassearch type="text" autocomplete="kirjanpitoaineistoarkki" [matAutocomplete]="asiakasAuto" [formField]="parent().nimi" (keydown.backspace)="tarkistaPoisto()" [placeholder]="'lasku.hae-tai-lisaa-asiakas' | translate | async" matInput data-lpignore="true" />
    </div>
    @if (onkoVirhe(nimi, 'required') && (nimi().dirty() || nimi().touched())) {
      <div class="lemon-error haun-virhe">{{ 'lasku.validation.nimi.required' | translate | async }}</div>
    }
    @if (onkoVirhe(nimi, 'minLength') && (nimi().dirty() || nimi().touched())) {
      <div class="lemon-error haun-virhe">{{ 'lasku.validation.nimi.minLength' | translate | async }}</div>
    }
    <mat-autocomplete #asiakasAuto="matAutocomplete" [displayWith]="displayFn" class="asiakashaun-lista">
      @for (asiakas of suodatetutAsiakkaat | async; track asiakas.avain) {
        <mat-option [value]="asiakas">
          <mat-icon>business</mat-icon>
          <span class="osuman-nimi">{{ asiakas.nimi }}</span>
          @if (asiakas.ytunnus != null) {
            <span class="osuman-ytunnus">{{ asiakas.ytunnus }}</span>
          }
        </mat-option>
      }
      @if (viimeisinHakuteksti()) {
        @if ((suodatetutAsiakkaat | async)?.length === 0) {
          <mat-option disabled class="ei-osumia">{{ 'lasku.ei-osumia-asiakasrekisterista' | translate | async }}</mat-option>
        }
        <mat-option [value]="viimeisinHakuteksti()" class="lisaa-uusi" (onSelectionChange)="lisaaUusiAsiakas($event)">
          <mat-icon>person_add</mat-icon>
          {{ 'lasku.lisaa-uusi-asiakas' | translate | async }} ”{{ viimeisinHakuteksti() }}”
        </mat-option>
      }
    </mat-autocomplete>
  }
</div>
